import { useCallback } from 'react';
import { clearApiCacheByTags } from '@/entities/helpers';
import { useTranslation } from 'react-i18next';
import { universalNotification } from '@/lib/utils/notification';
import {
  licenseActivationsApi,
  useDeactivateLicenceMutation
} from '@/entities/admin-app/activations/api';

export const useDeactivateLicense = () => {
  const { t } = useTranslation();
  const [handleDeactivateLicense] = useDeactivateLicenceMutation();
  return useCallback(async (licenseId: number) => {
    try {
      const res = await handleDeactivateLicense(licenseId);

      if ('error' in res) {
        universalNotification({
          error: `${(res as any)?.error}`,
          isError: true,
          isSuccess: false
        });
      } else {
        universalNotification({
          successTitle: t('license.deactivationSuccess'),
          isSuccess: true,
          isError: false,
          error: null
        });
        clearApiCacheByTags(licenseActivationsApi, ['LicenseList']);
      }
    } catch (err: any) {
      console.warn(t('filials.errors.save'), err);
    }
  }, []);
};
